import { Action } from '@ngrx/store';
import { Order } from '../../../../models/order.model';

export enum ActionType {

  ADD_ORDER = 'ADD_ORDER',
  ADD_ORDER_SUCCESS = 'ADD_ORDER SUCCESS',
  ADD_ORDER_FAILED = 'ADD_ORDER FAILED',
  DELETE_ORDER = 'DELETE_ORDER',
  DELETE_ORDER_SUCCESS = 'DELETE_ORDER SUCCESS',
  DELETE_ORDER_FAILED = 'DELETE_ORDER FAILED',
  FETCH_ORDERS = 'FETCH ORDERS',
  FETCH_ORDERS_SUCCESS = 'FETCH ORDERS SUCCESS',
  FETCH_ORDERS_FAILED = 'FETCH ORDERS FAILED',
  UPDATE_ORDER = 'UPDATE ORDER',
  UPDATE_ORDER_SUCCESS = 'UPDATE ORDER SUCCESS',
  UPDATE_ORDER_FAILED = 'UPDATE ORDER FAILED',
  FETCH_ORDERS_BY_COMPANYID = 'FETCH ORDERS BY COMPANYID',
  FETCH_ORDERS_BY_COMPANYID_SUCCESS = 'FETCH ORDERS BY COMPANYID SUCCESS',
  FETCH_ORDERS_BY_COMPANYID_FAILED = 'FETCH ORDERS BY COMPANYID FAILED',
  DESTROY_ORDER = 'DESTROY_ORDER',
  DESTROY_ORDER_SUCCESS = 'DESTROY_ORDER SUCCESS',
  DESTROY_ORDER_FAILED = 'DESTROY_ORDER FAILED',
  FETCH_ORDERS_BY_COMPANYIDSITEID = 'FETCH ORDERS BY COMPANYIDSITEID',
  FETCH_ORDERS_BY_COMPANYIDSITEID_SUCCESS = 'FETCH ORDERS BY COMPANYIDSITEID SUCCESS',
  FETCH_ORDERS_BY_COMPANYIDSITEID_FAILED = 'FETCH ORDERS BY COMPANYIDSITEID FAILED',
  FETCH_ORDERS_BY_USERID = 'FETCH ORDERS BY USERID',
  FETCH_ORDERS_BY_USERID_SUCCESS = 'FETCH ORDERS BY USERID SUCCESS',
  FETCH_ORDERS_BY_USERID_FAILED = 'FETCH ORDERS BY USERID FAILED',
}

export class DestroyOrder implements Action {
  readonly type = ActionType.DELETE_ORDER;

  constructor(public id: string) { }
}

export class DestroyOrderSuccess implements Action {
  readonly type = ActionType.DELETE_ORDER_SUCCESS;

  constructor(public id: string) { }
}

export class DestroyOrderFailed implements Action {
  readonly type = ActionType.DELETE_ORDER_FAILED;

  constructor() { }
}

export class FetchOrdersByCompanyIdSiteId implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_COMPANYIDSITEID;
  constructor(public companyId: string, public siteId: string) { }
}

export class FetchOrdersByCompanyIdSiteIdSuccess implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_COMPANYIDSITEID_SUCCESS;
  constructor(public orders: Order[]) { }
}

export class FetchOrdersByCompanyIdSiteIdFailed implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_COMPANYIDSITEID_FAILED;
  constructor(public error: any) { }
}






export class FetchOrdersByCompanyId implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_COMPANYID;
  constructor(public companyId: string) { }
}

export class FetchOrdersByCompanyIdSuccess implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_COMPANYID_SUCCESS;
  constructor(public orders: Order[]) { }
}

export class FetchOrdersByCompanyIdFailed implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_COMPANYID_FAILED;
  constructor(public error: any) { }
}

export class FetchOrders implements Action {
  readonly type = ActionType.FETCH_ORDERS;
  constructor() { }
}

export class FetchOrdersSuccess implements Action {
  readonly type = ActionType.FETCH_ORDERS_SUCCESS;
  constructor(public orders: Order[]) { }
}

export class FetchOrdersFailed implements Action {
  readonly type = ActionType.FETCH_ORDERS_FAILED;
  constructor(public error: any) { }
}

export class AddOrder implements Action {
  readonly type = ActionType.ADD_ORDER;

  constructor(public order: Order) { console.warn('order in AddOrder', order); }
}

export class AddOrderSuccess implements Action {
  readonly type = ActionType.ADD_ORDER_SUCCESS;

  constructor(public order: Order) { }
}

export class AddOrderFailed implements Action {
  readonly type = ActionType.ADD_ORDER_FAILED;

  constructor() { }
}

export class DeleteOrder implements Action {
  readonly type = ActionType.DELETE_ORDER;

  constructor(public id: string) { }
}

export class DeleteOrderSuccess implements Action {
  readonly type = ActionType.DELETE_ORDER_SUCCESS;

  constructor(public id: string) { }
}

export class DeleteOrderFailed implements Action {
  readonly type = ActionType.DELETE_ORDER_FAILED;

  constructor() { }
}

export class UpdateOrder implements Action {
  readonly type = ActionType.UPDATE_ORDER;

  constructor(public order: Order) { }
}

export class UpdateOrderSuccess implements Action {
  readonly type = ActionType.UPDATE_ORDER_SUCCESS;

  constructor(
    public id: string,
    public changes: Partial<Order>,
  ) { }
}

export class UpdateOrderFailed implements Action {
  readonly type = ActionType.UPDATE_ORDER_FAILED;

  constructor() { }
}

export class FetchOrdersByUserId implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_USERID;
  constructor(public userId: string) { }
}

export class FetchOrdersByUserIdSuccess implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_USERID_SUCCESS;
  constructor(public orders: Order[]) { }
}

export class FetchOrdersByUserIdFailed implements Action {
  readonly type = ActionType.FETCH_ORDERS_BY_USERID_FAILED;
  constructor(public error: any) { }
}

export type OrderActions =
  AddOrder | AddOrderFailed | AddOrderSuccess |
  UpdateOrder | UpdateOrderSuccess | UpdateOrderFailed |
  DeleteOrder | DeleteOrderSuccess | DeleteOrderFailed |
  FetchOrders | FetchOrdersSuccess | FetchOrdersFailed |
  FetchOrdersByCompanyId | FetchOrdersByCompanyIdSuccess | FetchOrdersByCompanyIdFailed |
  FetchOrdersByCompanyIdSiteId | FetchOrdersByCompanyIdSiteIdSuccess | FetchOrdersByCompanyIdSiteIdFailed |
  DestroyOrder | DestroyOrderSuccess | DestroyOrderFailed |
  FetchOrdersByUserId | FetchOrdersByUserIdSuccess | FetchOrdersByUserIdFailed
  ;



